var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { distributeRoles } from "../../../../api";
import { selectMatchState, setMatchState } from "../../../../store/match";
import { useAppDispatch, useAppSelector, useQuery } from "../../../../hooks";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { RolesCount } from "../../../molecules/RoleCountSetup/RoleCountSetup";
import * as api from "../../../../api/matches";
import { OldDeskPool } from "../../OldDeskPool";
const isButtonDisabled = (chosenRoles, players, starting) => {
    if (starting) {
        return false;
    }
    // @ts-ignore
    const chosenCount = Object.values(chosenRoles).reduce(
    // @ts-ignore
    (acc, number) => acc + number, 0);
    const playersCount = players.length;
    return chosenCount !== playersCount;
};
export function SelectRolesCount() {
    const { param: matchId } = useQuery("matchId");
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const allPlayers = (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [];
    const [chosenRoles, setChosenRoles] = useState({});
    const [starting, setStarting] = useState(false);
    const getAddOnComponent = () => (_jsx(RolesCount, { setChosenRoles: setChosenRoles }));
    const onStartGameClick = () => __awaiter(this, void 0, void 0, function* () {
        if (starting) {
            return;
        }
        try {
            console.log("chosenRoles", chosenRoles);
            // chosenRoles: {
            //   [alias]: count;
            // }
            setStarting(true);
            const result = yield distributeRoles((matchState === null || matchState === void 0 ? void 0 : matchState.id) || "", chosenRoles);
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
        }
        catch (err) {
            const result = yield api.getMatchState((matchState === null || matchState === void 0 ? void 0 : matchState.id) || "");
            dispatch(setMatchState(result));
            setStarting(false);
            errorHandler(err);
            console.error("MatchDesk onStartGameClick error", err.response);
        }
    });
    const gameButtonState = {
        text: starting ? "Игра начинается" : "Начать игру",
        visible: true,
        disabled: isButtonDisabled(chosenRoles, allPlayers, starting),
        onClick: onStartGameClick,
    };
    return (_jsx(OldDeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState, addOnComponent: getAddOnComponent }));
}
